import { render } from "./CarosuelLoader.vue?vue&type=template&id=85a6bc26&scoped=true"
import script from "./CarosuelLoader.vue?vue&type=script&lang=js"
export * from "./CarosuelLoader.vue?vue&type=script&lang=js"

import "./CarosuelLoader.vue?vue&type=style&index=0&id=85a6bc26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a6bc26"]])

export default __exports__